import React from "react";
import FormModal from "components/Modal/EditFormModal";
import AgeForm from "./AgeForm";
import { intlPlaceholder } from "util/intlPlaceholder";
import { useSelector } from "react-redux";
import { Form } from "antd";
const EditPetMainCategory = () => {
  const [form] = Form.useForm();
  const curdProps = useSelector((state) => state.CurdR);
  const { EDIT_AGE_MODAL } = curdProps;

  return (
    <div>
      <FormModal
        modalTitle={intlPlaceholder("age.editPageTittle")}
        editApiName="updateAge"
        ModalName="EDIT_AGE_MODAL"
        visible={EDIT_AGE_MODAL}
        isShowButton={false}
        width={500}
        recordName={"ageList"}
        form={form}
      >
        <AgeForm />
      </FormModal>
    </div>
  );
};

export default EditPetMainCategory;
